export default __webpack_public_path__ + "static/banner-find-the-best-car-loan-243cda3f476d6929bcb99173529692ed.jpg";